import "./LegalPage.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Header from "./Header";
import Footer from "./Footer";

export default function LegalPage({ title, lastUpdated, content }) {
  return (
    <div className="legal-page">
      <Header />
      <main className="legal-page__main">
        <div className="container legal-page__container">
          <h1 className="legal-page__title display-lg">{title}</h1>
          <p className="legal-page__updated">Last updated: {lastUpdated}</p>
          <div className="legal-page__content">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
